
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { objAny } from "../../common/common-interface";
import { State } from "vuex-class";
import { sysLoginOut } from "@/api/api-basic";
import { getBacklogSysDetail } from "@/api/oms-operation-service";
import i18n from "@/config/i18n";
@Component
export default class PiHeader extends Vue {
  @Prop({ default: "" }) private menuId!: string;
  @Prop({ default: false }) private isLogin!: boolean;
  @State("sys") sys!: objAny;
  @Watch("isLogin")
  getIsLogin(val: boolean) {
    if (val) {
      this.getBacklogSysDetail();
    }
  }
  @Watch("visible")
  getVisible(val: boolean) {
    if (val) {
      this.getBacklogSysDetail();
    }
  }

  private time = "";
  private navIndex = 1;
  private msgNum = 0;
  private userName: objAny = { operName: "--", position: "管理员" };
  private visible = false;
  private msgTipsList: objAny[] = [
    {
      key: "systemSmsPurchasedRecordAmount",
      name: "待审核短信购买",
      englishName: "SMS review not processed",
      thName: "รอซื้อ SMS",
      url: "/homepage/message/record?auditStatus=1"
    },
    {
      key: "systemNetSystemAmount",
      name: "待审核互联互通",
      englishName: "Interconnection not handled",
      thName: "การตรวจสอบการเชื่อมต่อโครงข่าย",
      url: "/homepage/audit-hlht-system?netStatus=0"
    },
    {
      key: "systemSettlementOrderAmount",
      name: "待处理分成账单",
      englishName: "Unprocessed share bill",
      thName: "ตั๋วเงินที่ต้องดำเนินการ",
      url: ""
    }
  ];

  public goOut(): void {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("header.outConfirm") + "",
      onOk: () => {
        this.sysLoginOut();
        // this.$Message.info("Clicked ok");
      },
      onCancel: () => {
        // this.$Message.info("Clicked cancel");
      }
    });
  }
  async sysLoginOut(): Promise<void> {
    await sysLoginOut({});
    this.$common.out();
  }

  public fullScreen(): void {
    const doc: objAny = document;
    const main = doc.body;
    if (this.isFullScreen()) {
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
      } else if (doc.webkitCancelFullScreen) {
        doc.webkitCancelFullScreen();
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
      }
    } else {
      if (main.requestFullscreen) {
        main.requestFullscreen();
      } else if (main.mozRequestFullScreen) {
        main.mozRequestFullScreen();
      } else if (main.webkitRequestFullScreen) {
        main.webkitRequestFullScreen();
      } else if (main.msRequestFullscreen) {
        main.msRequestFullscreen();
      }
    }
  }
  public isFullScreen(): boolean {
    const doc: objAny = document;
    const win: objAny = window;
    return (
      doc.body.scrollHeight == win.screen.height &&
      doc.body.scrollWidth == win.screen.width
    );
  }

  async getBacklogSysDetail() {
    const ret = await getBacklogSysDetail({});
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0];
      this.msgNum = data.totalAmount || 0;
      for (const i in data) {
        this.msgTipsList.map((item: objAny) => {
          if (i == item.key) {
            item.value = data[i];
          }
        });
      }
    }
  }

  mounted(): void {
    if (this.isLogin) {
      this.getBacklogSysDetail();
    }
    this.time = this.$common.thisTimes("yyyy-MM-dd HH:MM");
  }
}
